import { render, staticRenderFns } from "./DealLotOperation.vue?vue&type=template&id=20bcab89&"
import script from "./DealLotOperation.vue?vue&type=script&lang=js&"
export * from "./DealLotOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports